/**
 * 設定画面サイドバーの開閉状態管理Service
 * 設定画面のcollapsible状態を管理
 */
angular.module('inspinia').factory('settingSidebarStateService', function () {
  // collapsibleの開閉状態を保持
  let collapsibleStates = {
    dailyBoardOpen: true,
    childrenRecordOpen: true,
    billingGroupOpen: true,
  };

  // IPアドレス制限の表示状態を保持
  let ipRestrictionVisible = false;

  // 請求管理基本設定の表示状態を保持
  let billingBasicVisible = false;

  // 家庭からの連絡の表示状態を保持
  let parentContactsVisible = false;

  // Getters
  const getDailyBoardOpen = () => {
    return collapsibleStates.dailyBoardOpen;
  };

  const getMemberOpen = () => {
    return collapsibleStates.childrenRecordOpen;
  };

  const getBillingGroupOpen = () => {
    return collapsibleStates.billingGroupOpen;
  };

  // Setters
  const setDailyBoardOpen = (isOpen) => {
    collapsibleStates.dailyBoardOpen = isOpen;
  };

  const setMemberOpen = (isOpen) => {
    collapsibleStates.childrenRecordOpen = isOpen;
  };

  const setBillingGroupOpen = (isOpen) => {
    collapsibleStates.billingGroupOpen = isOpen;
  };

  // デイリーボード配下のページかチェック
  const isInDailyBoard = ($state) => {
    return (
      $state.includes('service.setting_whereabouts_check') ||
      $state.includes('service.setting_comments') ||
      $state.includes('service.setting_dailycheck') ||
      $state.includes('service.setting_meal')
    );
  };

  // 園児台帳配下のページかチェック
  const isInMember = ($state) => {
    return $state.includes('service.setting_member') || $state.includes('service.setting_development');
  };

  // 請求管理グループ配下のページかチェック
  const isInBillingGroup = ($state) => {
    return (
      $state.includes('service.setting_billing_basic') ||
      $state.includes('service.setting_charge') ||
      $state.includes('service.yokohama')
    );
  };

  // 現在のルートに基づいてサイドメニューの初期開閉状態を設定
  const initializeFromRoute = ($state) => {
    const inDailyBoard = isInDailyBoard($state);
    const inMember = isInMember($state);
    const inBillingGroup = isInBillingGroup($state);

    // 該当ページにいる場合は開く（閉じている場合のみ開く）
    if (inDailyBoard && !collapsibleStates.dailyBoardOpen) {
      setDailyBoardOpen(true);
    }

    if (inMember && !collapsibleStates.childrenRecordOpen) {
      setMemberOpen(true);
    }

    if (inBillingGroup && !collapsibleStates.billingGroupOpen) {
      setBillingGroupOpen(true);
    }
  };

  /**
   * IPアドレス制限メニューを表示するかどうかを判定して状態を更新
   * serviceSettingCtrlから呼び出される
   * @param {Object} service - サービス情報（open_date, attributesを含む）
   * @param {Object} system - システム定数
   */
  const updateIpRestrictionVisible = (service, system) => {
    if (service && service.open_date) {
      // SUで旧料金(=18料金: billing_system == 1)の施設の場合、無条件で表示
      if (service.attributes && service.attributes.billing_system == 1) {
        ipRestrictionVisible = true;
        return;
      }
      // SUで新料金(=20料金)の施設の場合、data_security_use属性がONの場合のみ表示
      if (service.attributes && service.attributes.data_security_use == system.FLAG_ON) {
        ipRestrictionVisible = true;
        return;
      }
    }
    ipRestrictionVisible = false;
  };

  /**
   * IPアドレス制限メニューの表示状態を取得
   * @returns {boolean} 表示する場合true
   */
  const isIpRestrictionVisible = () => {
    return ipRestrictionVisible;
  };

  /**
   * 請求管理基本設定メニューを表示するかどうかを判定して状態を更新
   * serviceSettingCtrlから呼び出される
   * @param {Object} service - サービス情報（attributesを含む）
   * @param {Object} system - システム定数
   */
  const updateBillingBasicVisible = (service, system) => {
    if (service && service.attributes && service.attributes.billing_use == system.FLAG_ON) {
      billingBasicVisible = true;
      return;
    }
    billingBasicVisible = false;
  };

  /**
   * 請求管理基本設定メニューの表示状態を取得
   * @returns {boolean} 表示する場合true
   */
  const isBillingBasicVisible = () => {
    return billingBasicVisible;
  };

  /**
   * 家庭からの連絡メニューを表示するかどうかを判定して状態を更新
   * localnaviServiceCtrlから呼び出される
   * @param {Object} service - サービス情報（plan_id, attributesを含む）
   * @param {Object} system - システム定数
   * @param {boolean} isBasicPlan - ベーシックプラン判定結果
   */
  const updateParentContactsVisible = (service, system, isBasicPlan) => {
    if (service && service.attributes) {
      const isSchoolFreePlan = parseInt(service.attributes.use_school_free_plan, 10) === system.FLAG_ON;
      parentContactsVisible = isSchoolFreePlan || isBasicPlan;
      return;
    }
    parentContactsVisible = false;
  };

  /**
   * 家庭からの連絡メニューの表示状態を取得
   * localNaviServiceCtrlから呼び出される（Getting）
   * @returns {boolean} 表示する場合true
   */
  const isParentContactsVisible = () => {
    return parentContactsVisible;
  };

  /**
   * ルートごとのアクセス権限チェック関数マップ
   * 各ルートに対応するチェック関数を定義
   */
  const routeAccessCheckers = {
    'service.setting_ip_restrictions': () => ipRestrictionVisible,
    'service.setting_billing_basic': () => billingBasicVisible,
    'service.parent_contacts': () => parentContactsVisible,
    // 他のルートの権限チェックをここに追加
    // 例: 'service.setting_xxxxx': () => xxxVisible,
  };

  /**
   * 指定されたルートへのアクセス権限をチェック
   * serviceSettingCtrlから呼び出される
   * @param {Object} $state - AngularJSの$stateオブジェクト
   * @returns {boolean} アクセス可能な場合true
   */
  const checkRouteAccess = ($state) => {
    const currentRoute = $state.current.name;
    const checker = routeAccessCheckers[currentRoute];

    // チェック関数が登録されている場合は実行
    if (checker) {
      return checker();
    }

    // チェック関数が登録されていない場合は常にアクセス可能
    return true;
  };

  /**
   * 全てのメニュー項目の表示状態を一括更新
   * localnaviServiceCtrlから呼び出される
   * @param {Object} service - サービス情報
   * @param {Object} system - システム定数
   * @param {boolean} isBasicPlan - ベーシックプラン判定結果
   */
  const updateAllMenuVisibility = (service, system, isBasicPlan) => {
    updateIpRestrictionVisible(service, system);
    updateBillingBasicVisible(service, system);
    updateParentContactsVisible(service, system, isBasicPlan);
  };

  return {
    getDailyBoardOpen,
    getMemberOpen,
    getBillingGroupOpen,
    setDailyBoardOpen,
    setMemberOpen,
    setBillingGroupOpen,
    initializeFromRoute,
    updateIpRestrictionVisible,
    isIpRestrictionVisible,
    updateBillingBasicVisible,
    isBillingBasicVisible,
    updateParentContactsVisible,
    isParentContactsVisible,
    checkRouteAccess,
    updateAllMenuVisibility,
  };
});
